// @ts-nocheck
import React from "react";
import { dateAdd } from "includes/formatDate";
import "./UserRow.css";
import { t } from "i18next";
import AuthorPreview, { DatePreview } from "components/User/AuthorPreview/AuthorPreview";
import genRequest from "includes/request";
import { useQuery } from "react-query";

export default function UserRow(props) {
	const {user, firstConnexion, status} = props;

	if (props.async)
		return (<AsyncUserRow {...props}/>);

	let propKey = "lastConnexion";

	if (firstConnexion)
		propKey = "firstConnexion";

	let isOnline = status !== false ? new Date(user[propKey]) > dateAdd(new Date(), {minutes: -5}) : false;

	return (
		<div className="UserRow d-flex align-items-center justify-content-between">
			<div className="d-flex align-items-center">
				{ props.children }
				<AuthorPreview
					className={"user-preview"}
					imgWidth={20}
					employeeId={user.employeeId}
					format={[
						"firstName lastName",
					]}
					modifiers={{
						lastName: (item) => item.toUpperCase()
					}}
				/>
			</div>
			{
				status !== false &&
					<div className="last-conn">
						{
							isOnline ?
								<div className="d-flex align-items-center">
									<div className="me-2">
										{t("Analytics.ONLINE")}
									</div>
									<div className="online-dot"></div>
								</div>
								:
								<DatePreview
									date={user[propKey]}
									max={1}
								/>
						}
					</div>
			}
		</div>
	);
}

export function AsyncUserRow(props) {

	const fetchMinimalEmploye = () => genRequest("employees/by-ids/" + props.employeeId);

	const {isLoading, data} = useQuery(
		["Employes", "MinimalContactEmployesFromId", props.employeeId],
		fetchMinimalEmploye,
		{
			enabled: (props.employeeId ? true : false),
			onSettled: props.onSettled
		}
	);

	if (!isLoading && data)
		return (
			<UserRow
				{...props}
				{...data}
				user={{
					...data,
					employeeId: data.id,
				}}
				async={false}
			/>
		);
	return (false);
}
